import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import JavascriptIcon from '@mui/icons-material/Javascript';
import TerminalIcon from '@mui/icons-material/Terminal';
import StorageIcon from '@mui/icons-material/Storage';
import MemoryIcon from '@mui/icons-material/Memory';

// 编程语言配置，包含语言名称、Judge0 ID、图标和颜色
const languages = [
  { value: 'c', label: 'C', icon: <MemoryIcon />, color: '#2196f3', judgeId: 50 },
  { value: 'cpp', label: 'C++', icon: <CodeIcon />, color: '#0d47a1', judgeId: 54 },
  { value: 'python', label: 'Python', icon: <TerminalIcon />, color: '#4caf50', judgeId: 71 },
  { value: 'javascript', label: 'JavaScript', icon: <JavascriptIcon />, color: '#ff9800', judgeId: 63 },
  { value: 'java', label: 'Java', icon: <StorageIcon />, color: '#f44336', judgeId: 62 }
];

// 根据语言标识获取Judge0 API的语言ID
export const getJudgeIdForLanguage = (languageValue) => {
  const language = languages.find(lang => lang.value === languageValue);
  return language ? language.judgeId : 50; // 默认为C语言
};

function LanguageSelector({ language, onLanguageChange }) {
  const handleChange = (event, newLanguage) => {
    if (newLanguage !== null) {
      onLanguageChange(newLanguage);
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        选择编程语言
      </Typography>
      <ToggleButtonGroup
        value={language}
        exclusive
        onChange={handleChange}
        aria-label="语言选择"
        sx={{ mb: 2 }}
      >
        {languages.map((lang) => (
          <ToggleButton 
            key={lang.value} 
            value={lang.value}
            sx={{ 
              px: 2, 
              py: 1,
              color: language === lang.value ? 'white' : lang.color,
              bgcolor: language === lang.value ? lang.color : 'transparent',
              '&.Mui-selected': {
                bgcolor: lang.color,
                '&:hover': {
                  bgcolor: lang.color,
                }
              },
              '&:hover': {
                bgcolor: `${lang.color}22`
              }
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {lang.icon}
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                {lang.label}
              </Typography>
            </Box>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}

export default LanguageSelector; 